import noop from 'utils/noop';

import { WalletPassState } from '../types';

import { UseGooglePass } from './types';

const useGooglePass: UseGooglePass = () => ({
  addGooglePass: noop,
  googlePassState: WalletPassState.DEFAULT,
  shouldRenderGooglePass: false
});

export default useGooglePass;
